import { ApiPathParam } from '../../../../../models/SearchParamSchema';
import { formAPIPageable } from '../../../../../utils/StringUtils';

export const GET_REGISTERED_EXAM = '/listing';
export const GET_EXAM_LEVELS = '/exam-levels';
export const POST_CHECK_EXAM_LEVELS = '/check-exam-level';
export const GET_EXAM_LEVEL_BY_CODE = '/exam-level';
export const POST_CREATE_WITHDRAWAL = '/withdrawals';
export const GET_WITHDRAWAL_SUMMARY = (uuid: string) => `/${uuid}/withdrawal-summary`;
export const GET_WITHDRAWAL_SELECTED_REASON = (uuid: string) => `/${uuid}/withdrawals-reason`;
export const PUT_WITHDRAWAL_REASON = (uuid: string) => `/${uuid}/withdrawals-reason`;
export const GET_WITHDRAWALS = '/withdrawals';
export const DELETE_GROUP_REGISTRATION = (uuid: string) => `${uuid}`;
export const POST_CANDIDATES = (uuid: string, params: ApiPathParam) => {
  const tparams = formAPIPageable(params);
  return `/${uuid}/exam-registration/candidates/search${tparams}`;
};
export const GET_WITHDRAWALS_SUMMARY = (uuid: string) => `/${uuid}/withdrawals-details`;
export const PUT_CONFIRM_WITHDRAWAL = (uuid: string) => `/${uuid}/withdrawals`;
export const POST_SEARCH_WITHDRAWAL_CANDIDATES = (uuid: string, params: ApiPathParam) => {
  const tparams = formAPIPageable(params);
  return `/${uuid}/withdrawal/candidates/search${tparams}`;
};
export const POST_ADDED_CANDIDATES = (uuid: string) => `/${uuid}/withdrawal`;
export const DELETE_ADDED_CANDIDATES = (applicationUuid: string, candidateUuid: string) =>
  `/${applicationUuid}/withdrawals/${candidateUuid}`;
export const GET_WITHDRAWAL_RESULT = (uuid: string) => `/${uuid}/withdrawal-result`;
export const GET_WITHDRAWAL_PDF = (uuid: string) => `/${uuid}/receipt/download`;
